import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { TsrctDemandProcessStatus } from '@/generated/gql/graphql';
import { DemandProcessStatusChip } from '~/components/DemandProcessStatusChip/DemandProcessStatusChip';

export type DemandProcessStatusChipCellValue = Union.Nullable<keyof typeof TsrctDemandProcessStatus>;

interface DemandProcessStatusChipCellProps<R extends GridValidRowModel = any> {
  value: DemandProcessStatusChipCellValue;
  row: R;
}

export const DemandProcessStatusChipCell = <R extends GridValidRowModel = any>({
  value,
}: DemandProcessStatusChipCellProps<R>) => {
  // div wrapper needed to display chip correctly
  return value ? (
    <div>
      <DemandProcessStatusChip processStatus={value} />
    </div>
  ) : (
    <>{NULLISH_CELL_VALUE}</>
  );
};
